module.exports = __webpack_public_path__ + "static/media/partner4.382147af.png";